<template>
	<div id="app" class="d-flex flex-column wrapper">
		<navbar />
		<!-- <nutritional-banner v-if="tokenStore.hasToken()" /> -->
		<offline-banner />
		<new-version />
		<trial-banner />
		<!-- <ad-test /> -->
		<main class="flex-fill">
			<RouterView />
			<FruitRain :density="30" />
			<!--<button class="btn btn-lg btn-success" @click="testNotif">TEST</button>-->
		</main>
		<app-footer />
		<loader />
		<!-- <MobileAd v-if="Capacitor.isNativePlatform()" /> -->
		<!-- <upgrade-to-plus v-else /> -->
		<upgrade-to-plus />
		<data-policy-dialog />
		<subscription-modal />
	</div>
</template>

<script setup>
	import { nextTick, onBeforeMount, onBeforeUnmount } from "vue"
	import { RouterView } from "vue-router"
	import Navbar from "./components/Navbar.vue"
	import AppFooter from "./components/AppFooter.vue"
	// import NutritionalBanner from "./components/NutritionalBanner.vue"
	import OfflineBanner from "./components/OfflineBanner.vue"
	import Loader from "./components/Loader.vue"
	import NewVersion from "./components/NewVersion.vue"
	import TrialBanner from "./components/TrialBanner.vue"
	import DataPolicyDialog from "./components/DataPolicyDialog.vue"
	// import { useTokenStore } from "./stores/token"
	// import { useDataPolicyStore } from "./stores/data-policy"
	import { initOnlineListener, removeOnlineListener } from "./utils/networkBus"
	// import { bloodSugarNotif } from "./utils/notif"
	import SubscriptionModal from "./components/SubscriptionModal.vue"
	import UpgradeToPlus from "./components/UpgradeToPlus.vue"
	import FruitRain from "./components/FruitRain.vue"
	// import { App } from "@capacitor/app"
	// import { Filesystem, Directory, Encoding } from "@capacitor/filesystem"
	// import { useRouter } from "vue-router"

	//UNCOMMENT WHEN TO BRING BACK ADS
	// import MobileAd from "./components/MobileAd.vue"
	// import { Capacitor } from "@capacitor/core"

	// const router = useRouter()
	// const route = useRoute()
	// const tokenStore = useTokenStore()
	// const dataPolicyStore = useDataPolicyStore()

	// tokenStore.loadTokens()
	// dataPolicyStore.loadDataPolicyAgreement()

	initOnlineListener()

	// async function testNotif() {
	// 	await bloodSugarNotif("lunch", 0.01, new Date().toISOString())
	// }

	// onBeforeMount(() => {
	// 	//inject a script tag to the head of the document if it does not already exist
	// 	if (!document.getElementById("ad-test") && !Capacitor.isNativePlatform()) {
	// 		const script = document.createElement("script")
	// 		script.id = "ad-test"
	// 		script.src =
	// 			"https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6225091491024428"
	// 		script.crossOrigin = "anonymous"
	// 		script.async = true
	// 		document.head.appendChild(script)
	// 	}
	// })

	// onBeforeMount(async () => {
	// 	// await tokenStore.loadTokens()
	// 	App.addListener("appRestoredResult", async (event) => {
	// 		if (event.pluginId === "Camera" && event.success) {
	// 			//restore
	// 			//read the state.json file
	// 			const state = await Filesystem.readFile({
	// 				path: "state.json",
	// 				directory: Directory.Data,
	// 				encoding: Encoding.UTF8,
	// 			})
	// 			// alert(state.data)
	// 			const stateObj = JSON.parse(state.data)
	// 			// alert("GOING TO: " + stateObj.route)

	// 			// // //inject the camera data into the state
	// 			// stateObj.cameraData = event.data.dataUrl

	// 			// //save to file
	// 			// await Filesystem.writeFile({
	// 			// 	path: "state.json",
	// 			// 	data: JSON.stringify(stateObj),
	// 			// 	directory: Directory.Data,
	// 			// })

	// 			//now redirect to the route
	// 			// nextTick(() => {
	// 			router.push({
	// 				path: stateObj.route,
	// 				query: { restored: "from_camera" },
	// 			})
	// 			// })
	// 		}
	// 	})
	// })

	onBeforeUnmount(() => {
		removeOnlineListener()
		// App.removeAllListeners()
	})
</script>

<style scoped>
	.wrapper {
		min-height: 100vh;
		flex-direction: column;
		display: flex;
		position: relative;
		z-index: 1; /* ensure all app content is above background effects like FruitRain */
	}

	main.flex-fill {
		flex: 1 0 auto;
	}
</style>
